import { Box, SxProps, useMediaQuery, useTheme } from '@mui/material'
import { FC } from 'react'
import { Outlet } from 'react-router'
import { TestStripHeader } from '../Header'

import { WaterInfoDrawer } from '../WaterInfoDrawer'

interface MainProps {
  sx?: SxProps
}

export const TestStripLayout: FC<MainProps> = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <TestStripHeader />
      <Outlet />
      <WaterInfoDrawer
        anchor={isMobile ? 'bottom' : 'right'}
        PaperProps={{
          sx: {
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
            },
            width: isMobile ? '100%': '560px',
            height: isMobile ? '90%' : '100%',
            borderRadius: 0,
            //overflow: 'hidden',
            zIndex: theme.zIndex.drawer + 100,
            position: 'absolute',
            borderTopLeftRadius: isMobile ? '24px' : 0,
            borderTopRightRadius: isMobile ? '24px' : 0,
            bgcolor: theme.palette.success.contrastText,
          },
        }}
      />
    </Box>
  )
}
